import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  theme => ({
    radiusContainer: {
      marginTop: theme.spacing(1)
    }
  }),
  { name: 'CityFilter' }
);
